import { endOfDay, endOfMonth, endOfYear, getYear, setYear, startOfMonth, startOfYear, subMonths } from 'date-fns';

import { CalendarRangePreset } from '../../cdl/DateRangePicker/types/CalendarRangePreset';
import { RangeDirection } from '../../cdl/DateRangePicker/types/RangeDirection';

import { translate } from './translate.helper';

export function generateStatisticsDateRangePresets() {
    const presets: CalendarRangePreset[] = [];

    const now = new Date();
    const currentYear = getYear(now);

    const currentDate = endOfDay(now);

    const currentDateSubtractedBySixMonths = endOfDay(subMonths(now, 6));

    // Generate the last six months preset
    presets.push({
        label: translate('reporting.dateRangePresets.lastSixMonths'),
        range: [currentDateSubtractedBySixMonths, currentDate],
        direction: RangeDirection.Backward,
    });

    const currentYearStartDate = startOfYear(setYear(now, currentYear));

    // Generate the current month preset
    const currentMonthStartDate = startOfMonth(now);
    presets.push({
        label: translate('reporting.dateRangePresets.currentMonth'),
        range: [currentMonthStartDate, currentDate],
        direction: RangeDirection.Forward,
    });

    // Generate the last month preset
    const lastMonth = subMonths(now, 1);
    const lastMonthStartDate = startOfMonth(lastMonth);
    const lastMonthEndDate = endOfMonth(lastMonth);
    presets.push({
        label: translate('reporting.dateRangePresets.lastMonth'),
        range: [lastMonthStartDate, lastMonthEndDate],
        direction: RangeDirection.Backward,
    });

    // Generate the current year preset
    presets.push({
        label: translate('reporting.dateRangePresets.currentYear', {
            year: currentYear.toString(),
        }),
        range: [currentYearStartDate, currentDate],
        direction: RangeDirection.Backward,
    });

    // Generate the last year preset
    const lastYearStartDate = startOfYear(setYear(now, currentYear - 1));
    const lastYearEndDate = endOfYear(setYear(now, currentYear - 1));

    presets.push({
        label: translate('reporting.dateRangePresets.lastYear', {
            year: (currentYear - 1).toString(),
        }),
        range: [lastYearStartDate, lastYearEndDate],
        direction: RangeDirection.Backward,
    });

    return presets;
}
